import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './ContactMain.module.css';
import { useFormik } from 'formik';
import { motion, AnimatePresence } from 'framer-motion';
import { validationSchema } from '../../../assets/contactValidationSchema/validationSchema';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Warning from './Warning.jsx';

const ContactMain = () => {
  const { t } = useTranslation();

  const {
    handleSubmit,
    handleBlur,
    handleChange,
    values,
    errors,
    touched,
    // isSubmitting,
  } = useFormik({
    initialValues: {
      name: '',
      lastName: '',
      email: '',
      text: '',
    },
    validationSchema,
    onSubmit: async (values, actions) => {
      const body = new FormData();
      Object.entries(values).forEach(([key, val]) => {
        body.append(key, val);
      });

      const res = await fetch(
        'https://getform.io/f/b6eb4c30-4aae-4130-a5e2-cfba62b93401', //tim test
        {
          method: 'POST',
          headers: { accept: 'application/json' },
          body,
        }
      );

      if (!res.ok) {
        // console.error(res.status, await res.text());
      } else {
        // console.log(await res.json());
        await new Promise((resolve) => setTimeout(resolve, 700));
        toast.success(t('lang.toastSendSuccess'));
        // toast.success(contactText.toast);
        // console.log('submitted');
        actions.resetForm();
      }
    },
  });

  // useEffect(() => {
  //   const lng = navigator.language;

  //   i18n.changeLanguage(lng);
  // }, []);
  return (
    <div className={styles.container}>
      <AnimatePresence>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1 }}
          exit={{ opacity: 0 }}
          className={styles.imgContainer}
        >
          <img
            src='https://i.ibb.co/1vL6FvR/Untitled.png'
            alt=''
            className={styles.img}
          />

          {/* <img
          src="https://i.ibb.co/1vL6FvR/Untitled.png"
          alt=""
          className={styles.imgBig}
        /> */}
        </motion.div>
      </AnimatePresence>

      <div className={styles.mainForm}>
        <div className={styles.titleContainer}>
          <h1 className={styles.title}>{t('lang.contactTitle')}</h1>

          {/* <p className={styles.text}>{t('lang.contactText')}</p> */}
        </div>

        <div className={styles.formContainer}>
          <form action='' method='post' onSubmit={handleSubmit}>
            <label htmlFor='' className={styles.inpLabel}>
              {t('lang.contactLabelName')} *
            </label>
            <div className={styles.inpBox}>
              <input
                value={values.name}
                onChange={handleChange}
                onBlur={handleBlur}
                type='text'
                placeholder={t('lang.contactFirstName')}
                className={styles.nameInp}
                name='name'
                id='name'
                required
              />

              {touched.name && <Warning err={errors.name} />}

              {/* <div>{errors.name}</div> */}
              {/* {toast.warning(errors.name)} */}

              <input
                value={values.lastName}
                onChange={handleChange}
                onBlur={handleBlur}
                type='text'
                placeholder={t('lang.contactLastName')}
                className={styles.nameInp}
                name='lastName'
                id='lastName'
                required
              />

              {touched.lastName && <Warning err={errors.lastName} />}

              {/* <Warning err={errors.lastName} /> */}
              {/* {touched.lastName && errors.lastName} */}
            </div>

            <label htmlFor='' className={styles.inpLabel}>
              {t('lang.contactLabelEmail')} *
            </label>
            <div className={styles.inpBox}>
              <input
                value={values.email}
                onChange={handleChange}
                onBlur={handleBlur}
                type='email'
                placeholder='address@example.com'
                className={styles.emailInp}
                name='email'
                id='email'
                required
              />
              {touched.email && <Warning err={errors.email} />}

              {/* <Warning err={errors.email} /> */}
              {/* {touched.email && errors.email} */}
            </div>

            <label htmlFor='' className={styles.inpLabel}>
              {t('lang.contactLabelMessage')} *
            </label>
            <div className={styles.messageBox}>
              <textarea
                value={values.text}
                onChange={handleChange}
                onBlur={handleBlur}
                name='text'
                id='text'
                // cols="30"
                rows='6'
                placeholder={t('lang.contactMessage')}
                className={styles.message}
                required
              ></textarea>
              {touched.text && <Warning err={errors.text} />}
              {/* <Warning err={errors.text} /> */}
            </div>

            <div className={styles.linkBox}>
              {/* <div className={styles.linkButton}> */}
              <button type='submit' className={styles.submitBtn}>
                {t('lang.send')}
              </button>
              {/* </div> */}
            </div>
            <ToastContainer />
          </form>
        </div>
      </div>
    </div>
  );
};

export default ContactMain;
